import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

const setSiloEquipmentData = (state, { siloEquipmentData }) => {
  if (!siloEquipmentData) return state;
  return state.merge({ siloEquipmentData });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_SILO_EQUIPMENT_DATA,
    actionFunction: setSiloEquipmentData,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
];
